import * as yup from 'yup';
import _ from "lodash"
import { appComponents as i18nNamespace } from "../../i18n/namespace";
import { getLocalizedValue as t } from "../../i18n";

yup.setLocale({
    mixed: {
        required: t("mandatory_fields", i18nNamespace),
    },
    string: {
        matches: t("field_not_matched", i18nNamespace)
    }
});

yup.addMethod(yup.array, "uniqueBy", function (message, mapPath, isCaseSensitive) {
    return this.test("uniqueBy", message, function (list) {
        const map = {};
        const foundIndex = _.findIndex(list, (item) => {
            let property = _.get(item, mapPath);

            if (isCaseSensitive) {
                property = (property || "").toLowerCase();
            }

            if (!map[property]) {
                map[property] = true
            } else {
                return true
            }
        })

        if (foundIndex > 0) {
            return this.createError({path: `${this.path}[${foundIndex}].${mapPath}`, message});
        } else {
            return true
        }
    });
});

yup.addMethod(yup.array, "unique", function (message, path) {
    return this.test("unique", message, function (list) {
        const seen = new Map();
        const errors = [];
        for (let i = 0; i < list.length; i++) {
            const value = list[i];
            if (seen.has(value)) {
                errors.push(this.createError({ path: `${path}[${i}]`, message }));
            }
            seen.set(value, true);
        }
        if (errors.length > 0) {
            return new yup.ValidationError(errors);
        }
        return true;
    });
  });

yup.addMethod(yup.string, "uniqueWith", function (fields, message) {
    return this.test("uniqueWith", message, function (value) {
        if(!value) return true;

        for(const field of fields) {
            const siblingValue = this.parent[field];
            if(siblingValue && siblingValue === value) {
                return false;
            }
        }

        return true;
    });
});

yup.addMethod(yup.object, "extensionOrExtensions", function (message, extensionOrExtensions) {
    return this.test("extensionOrExtensions", message, function (file) {
        const extension = _.isArray(extensionOrExtensions) ? extensionOrExtensions : [extensionOrExtensions]
        if (!file || _.some(extension, extension => file.fileName?.endsWith(extension))) {
            return true
        } else {
            this.createError({ path: `${this.path}`, message });
        }
    });
});

yup.addMethod(yup.object, "fileSize", function (message, maxSizeInBytes) {
    return this.test("fileSize", message, function (file) {
        if (!file || file.contents?.length <= maxSizeInBytes) {
            return true
        } else {
            this.createError({path: `${this.path}`, message});
        }
    });
});

yup.addMethod(yup.string, "matchesField", function(field, message) {
    return this.test("matchesField", message, function(value) {
        return (!this.parent[field] && !value) || this.parent[field] === value
    })
})